<div class="whitelabel-container">
	<div class="header d-f jc-sb ai-c">
		<div>
			<h1>Configuração dos canais</h1>
			<p class="header-text" *ngIf="organizationName">
				Gestão centralizada da Sanus para as empresas matriz
			</p>
		</div>
	</div>

	<div class="d-f jc-c ai-c w-100 py-md" *ngIf="isLoading">
		<mat-spinner diameter="30"></mat-spinner>
	</div>

	<div class="empty-state" *ngIf="!isLoading && isUnauthorizedSanusAccess">
		<p>Essa funcionalidade fica disponível apenas no contexto da Sanus.</p>
	</div>

	<ng-container *ngIf="!isLoading && !isUnauthorizedSanusAccess">
		<div class="content-grid">
			<section class="panel form-section">
				<div class="panel-header">
					<h3>
						{{
							editingWhitelabelId
								? 'Editar whitelabel'
								: 'Criar novo canal whitelabel'
						}}
					</h3>
					<p class="panel-description">
						Cadastre os whitelabels disponíveis para atribuição nas empresas
						matriz.
					</p>
				</div>
				<form [formGroup]="whitelabelForm" class="form-grid">
					<div class="form-field">
						<p class="label">Nome</p>
						<input
							formControlName="name"
							type="text"
							placeholder="Ex.: Grupo Wiz"
						/>
						<mat-error
							*ngIf="
								whitelabelForm.get('name')?.hasError('required') &&
								whitelabelForm.get('name')?.touched
							"
						>
							O nome é obrigatório.
						</mat-error>
					</div>
				</form>

				<div class="panel-actions">
					<button
						mat-stroked-button
						type="button"
						*ngIf="editingWhitelabelId"
						(click)="cancelEdit()"
					>
						Cancelar
					</button>
					<button
						mat-raised-button
						color="primary"
						type="button"
						[disabled]="whitelabelForm.invalid || isSavingWhitelabel"
						(click)="saveWhitelabel()"
					>
						{{
							isSavingWhitelabel
								? 'Salvando...'
								: editingWhitelabelId
									? 'Atualizar'
									: 'Criar'
						}}
					</button>
				</div>
			</section>

			<section class="panel list-section">
				<div class="panel-header">
					<h3>Canais whitelabel cadastrados</h3>
					<p class="panel-description">
						{{ whitelabels.length }} disponível(is) para a Sanus.
					</p>
				</div>

				<div class="empty-state compact" *ngIf="!whitelabels.length">
					<p>Nenhum canal whitelabel cadastrado até o momento.</p>
				</div>

				<div class="whitelabel-list" *ngIf="whitelabels.length">
					<div
						*ngFor="let whitelabel of whitelabels; trackBy: trackWhitelabel"
						class="whitelabel-card"
					>
						<div>
							<p class="whitelabel-name">{{ formatWhitelabel(whitelabel) }}</p>
							<span>{{ whitelabel.slug }}</span>
						</div>
						<button
							mat-button
							type="button"
							(click)="editWhitelabel(whitelabel)"
						>
							Editar
						</button>
					</div>
				</div>
			</section>
		</div>

		<section class="panel assignment-section">
			<div class="panel-header">
				<h3>Atribuição por grupo econômico</h3>
				<p class="panel-description">
					Selecione as empresas matriz. As filiais herdam automaticamente o
					whitelabel aplicado.
				</p>
			</div>

			<form [formGroup]="assignmentForm" class="assignment-toolbar">
				<div class="form-field">
					<p class="label">Whitelabel para aplicar</p>
					<select formControlName="whitelabelId">
						<option value="" disabled selected>Selecione um whitelabel</option>
						<option
							*ngFor="let whitelabel of whitelabels; trackBy: trackWhitelabel"
							[value]="whitelabel.id"
						>
							{{ formatWhitelabel(whitelabel) }}
						</option>
					</select>
				</div>

				<div class="assignment-actions">
					<button
						mat-stroked-button
						type="button"
						[disabled]="!hasSelection || isSavingAssignment"
						(click)="removeWhitelabel()"
					>
						Remover das matrizes selecionadas
					</button>
					<button
						mat-raised-button
						color="primary"
						type="button"
						[disabled]="
							assignmentForm.invalid || !hasSelection || isSavingAssignment
						"
						(click)="applyWhitelabel()"
					>
						{{
							isSavingAssignment
								? 'Aplicando...'
								: 'Aplicar às matrizes selecionadas'
						}}
					</button>
				</div>
			</form>

			<div class="selection-summary d-f jc-sb ai-c">
				<p class="selection-summary-text">
					{{ selectedCount }} matriz(es) selecionada(s)
				</p>
				<div class="selection-summary-actions">
					<div class="search-field form-field">
						<input
							type="text"
							placeholder="Buscar matriz por nome"
							[value]="searchTerm"
							(input)="onSearchChange($any($event.target).value)"
						/>
					</div>
					<mat-checkbox
						[checked]="allSelected"
						(change)="toggleAllOrganizations()"
						[disabled]="!filteredMatrices.length"
					>
						Selecionar todas
					</mat-checkbox>
				</div>
			</div>

			<div class="empty-state compact" *ngIf="!matrices.length">
				<p>Nenhuma empresa matriz encontrada para atribuição.</p>
			</div>

			<div
				class="empty-state compact"
				*ngIf="matrices.length && !filteredMatrices.length"
			>
				<p>Nenhuma matriz encontrada para a busca informada.</p>
			</div>

			<div class="subsidiaries-list" *ngIf="filteredMatrices.length">
				<div
					*ngFor="
						let organization of filteredMatrices;
						trackBy: trackOrganization
					"
					class="subsidiary-card"
					[class.selected]="isOrganizationSelected(organization.id)"
					(click)="toggleOrganization(organization.id)"
					(keydown)="onOrganizationKeydown($event, organization.id)"
					tabindex="0"
				>
					<mat-checkbox
						[checked]="isOrganizationSelected(organization.id)"
						(click)="$event.stopPropagation()"
						(change)="toggleOrganization(organization.id)"
					></mat-checkbox>

					<div class="subsidiary-content">
						<div>
							<p class="subsidiary-name">
								{{ organization.name_secondary || organization.name }}
							</p>
							<span>
								{{ organization.name }} • filiais herdam automaticamente
							</span>
						</div>
						<span
							class="whitelabel-badge"
							[class.empty]="!organization.whitelabel"
						>
							{{
								organization.whitelabel
									? formatWhitelabel(organization.whitelabel)
									: 'Sem whitelabel'
							}}
						</span>
					</div>
				</div>
			</div>
		</section>
	</ng-container>
</div>
